import { Alert } from "@mui/material";

export default function MonthFallbackNotice({ requestedMonth, activeMonth, entityLabel = "A empresa selecionada" }) {
  if (!requestedMonth || !activeMonth || requestedMonth === activeMonth) {
    return null;
  }

  return (
    <Alert severity="info" variant="outlined" sx={{ mb: 2 }}>
      {entityLabel} não possui dados para {requestedMonth}. Exibindo {activeMonth}, período disponível mais próximo.
    </Alert>
  );
}
